export type EmailDeliveryStatusType = 'PENDING' | 'SENT' | 'FAILED';

export interface ContactEmailDeliveryProps {
  id: string;
  contactMessageId: string;
  recipientEmail: string;
  subject: string;
  status: EmailDeliveryStatusType;
  providerMessageId?: string | null;
  errorMessage?: string | null;
  sentAt?: Date | null;
  createdAt: Date;
}

export class ContactEmailDelivery {
  private readonly _id: string;
  private readonly _contactMessageId: string;
  private readonly _recipientEmail: string;
  private readonly _subject: string;
  private _status: EmailDeliveryStatusType;
  private _providerMessageId?: string | null;
  private _errorMessage?: string | null;
  private _sentAt?: Date | null;
  private readonly _createdAt: Date;

  private constructor(props: ContactEmailDeliveryProps) {
    this._id = props.id;
    this._contactMessageId = props.contactMessageId;
    this._recipientEmail = props.recipientEmail;
    this._subject = props.subject;
    this._status = props.status;
    this._providerMessageId = props.providerMessageId;
    this._errorMessage = props.errorMessage;
    this._sentAt = props.sentAt;
    this._createdAt = props.createdAt;
  }

  public static create(props: {
    id: string;
    contactMessageId: string;
    recipientEmail: string;
    subject: string;
    status: EmailDeliveryStatusType;
    providerMessageId?: string | null;
    errorMessage?: string | null;
    sentAt?: Date | string | null;
    createdAt?: Date | string;
  }): ContactEmailDelivery {
    return new ContactEmailDelivery({
      id: props.id,
      contactMessageId: props.contactMessageId,
      recipientEmail: props.recipientEmail,
      subject: props.subject,
      status: props.status,
      providerMessageId: props.providerMessageId,
      errorMessage: props.errorMessage,
      sentAt: props.sentAt ? new Date(props.sentAt) : null,
      createdAt: props.createdAt ? new Date(props.createdAt) : new Date(),
    });
  }

  public get id(): string {
    return this._id;
  }

  public get contactMessageId(): string {
    return this._contactMessageId;
  }

  public get recipientEmail(): string {
    return this._recipientEmail;
  }

  public get subject(): string {
    return this._subject;
  }

  public get status(): EmailDeliveryStatusType {
    return this._status;
  }

  public get providerMessageId(): string | null | undefined {
    return this._providerMessageId;
  }

  public get errorMessage(): string | null | undefined {
    return this._errorMessage;
  }

  public get sentAt(): Date | null | undefined {
    return this._sentAt;
  }

  public get createdAt(): Date {
    return this._createdAt;
  }
}
